/* __next_internal_client_entry_do_not_use__ MaybeProminentPriceFirstSlotter auto */ import { useSettingProminentPriceFirstProductTile } from "@faire/retailer/settings/useSettingProminentPriceFirstProductTile";
export var MaybeProminentPriceFirstSlotter = function(param) {
    var isPriceFirstSlot = param.isPriceFirstSlot, children = param.children;
    var settingValue = useSettingProminentPriceFirstProductTile();
    var showChildren = settingValue && isPriceFirstSlot || !settingValue && !isPriceFirstSlot;
    return showChildren ? children : null;
};
